module.exports = __webpack_public_path__ + "media/images/mamari/wowma/about-bg-ac5275361dcbab9064ced92583d16f72.png";